import { render, staticRenderFns } from "./exportSegmentUsersPopup.vue?vue&type=template&id=0bbdf201&"
import script from "./exportSegmentUsersPopup.vue?vue&type=script&lang=js&"
export * from "./exportSegmentUsersPopup.vue?vue&type=script&lang=js&"
import style0 from "./exportSegmentUsersPopup.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports